import ScrollTextHome from "./ScrollTextHome";

export default ScrollTextHome;
